<template>
  <transition name="Tutorial">
  <div class="Tutorial">
    <div class="swiper-container Tutorial__container" ref="swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide Tutorial__slide" v-for="n in 3">
          <div class="Tutorial__inner">
            <div class="Tutorial__cover">
              <img :src="require('./img/Perso' + n + '.png')" />
            </div>
            <div class="Tutorial__close" @click="$store.commit('user/SET_TUTORIAL', false)">
              <img :src="require('./img/close.png')" />
            </div>
            <div class="Tutorial__title">{{ trans('titles')[n-1] }}</div>
            <div class="Tutorial__description">{{ trans('descriptions')[n-1] }}</div>
            <div class="Tutorial__btn Btn is-border-black" @click="$store.commit('user/SET_TUTORIAL', false)" v-if="n == 1 || n == 2"><img :src="require('./img/map.png')" />{{ trans('btns')[n-1] }}</div>
            <div class="Tutorial__btn Btn is-border-black" @click="$router.push({ name: 'selfie.' + lang })" v-if="n == 3"><img class="is-camera" :src="require('./img/camera.png')" />{{ trans('btns')[n-1] }}</div>
          </div>
        </div>
      </div>
      <div ref="pagination" class="swiper-pagination Tutorial__pagination"></div>
    </div>
  </div>
  </transition>
</template>

<script>
import Swiper from 'swiper'
require('swiper/dist/css/swiper.css')

export default {
  name: 'Tutorial',
  data: () => ({
    icons: ['map', 'camera', 'map']
  }),
  translations: {
    fr: {
      titles: [
        'Alegría prend vie grâce à la réalité augmentée!',
        "Obtenez 15% de rabais sur la marchandise aujourd'hui en partageant deux photos sur Facebook",
        'Prenez des égoportraits uniques tels que les chapeaux des personnages',
      ],
      descriptions: [
        "Repérez les icônes à l'entrée du site, la couronne, le château de cartes et le trône.",
        '',
        '',
      ],
      btns: ['Explorer la carte', 'Explorer la carte', 'Prendre un égoportrait'],
    },
    en: {
      titles: [
        'Alegría comes to life with augmented reality!',
        'Unlock 15% off merchandise today by sharing two photos on Facebook ',
        "Take funny selfies, such as characters' hats",
      ],
      descriptions: [
        'Look for markers at the site entrance, and at the house of cards, crown and throne.',
        '',
        '',
      ],
      btns: ['Explore the map', 'Explore the map', 'Take a selfie'],
    }
  },
  mounted() {

    this.$swiper = new Swiper(this.$refs.swiper, {
      slidesPerView: 1.2,
      spaceBetween: 0,
      centeredSlides: true,
      pagination: {
        el: this.$refs.pagination,
      }
    })

  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Tutorial
  position fixed
  height 100%
  width 100%
  background rgba(black, .2)
  z-index 9
  top 0
  left 0
  transition opacity 1s
  &-enter
  &-leave-active
    opacity 0

  &__cover
    height 200px
    width 200px
    margin 0 auto

  &__close
    position absolute
    right 20px
    top 20px

  &__container
    top 50%
    transform translateY(-50%)
    padding-bottom 50px

  &__slide
    background white
    border-radius 10px
    transition transform .5s
    transform scale(.9)
    &.swiper-slide-active
      transform scale(1)

  &__inner
    padding 35px 30px 50px
    text-align center

  &__title
    color black
    font-size 16px
    font-weight 700
    line-height 24px
    padding 0 20px

  &__description
    color #A09C94
    font-size 13px
    margin 10px 0
    line-height 22px
    letter-spacing .19px
    padding 0 20px

  &__pagination
    .swiper-pagination-bullet
      background white
      opacity .3
    .swiper-pagination-bullet-active
      background white
      opacity 1




</style>
